import { resultsPageQuery, getChecklistResultsPages } from '@lib/queries'
import { getClient } from '@lib/sanity.server'
import PropTypes from 'prop-types'
import Template from 'templates/Page'
import PagePreview from '@components/PagePreview'
import dynamic from 'next/dynamic'
import resolveLink from '@utils/resolveLink'
const PreviewProvider = dynamic(() => import('../../components/PreviewProvider'), {
	ssr: false,
})

const Page = ({ preview, data }) => {
	return (
		!preview ? <Template data={data}/> :
			<PreviewProvider>
				<PagePreview
					renderTemplate={liveData => <Template data={liveData} />}
					initialData={data} 
					query={resultsPageQuery} 
					slug={data?.page?.slug} 
				/>
			</PreviewProvider>
	)
}

export const getStaticProps = async ({ preview = false, params }) => {
	const client = getClient(preview)
	const data = await client.fetch(resultsPageQuery, {associatedSlug: params.slug[0], response: params.slug[1]})
	
	return {props: {preview, data}}
}

export async function getStaticPaths() {
	const pages = await getClient().fetch(getChecklistResultsPages())
	
	const paths = pages.map(page => ([
		page?.associatedChecklist?.slug?.current,
		page?.response
	]))

	return {
		paths: paths.map(slug => ({ params: { slug } })),
		fallback: false,
	}
}

Page.propTypes = {
	data: PropTypes.object,
	preview: PropTypes.bool,
}

export default Page